import { v4 as uuidv4 } from 'uuid';

export const pointsShopSections = [
  {
    id: uuidv4(),
    title: 'Featured',
    sectionItems: [
      {
        id: uuidv4(),
        name: 'Featured Home',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'From Your Games',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'From Sales and Events',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Bundles',
        amount: '5,000',
      },
    ],
  },
  {
    id: uuidv4(),
    title: 'Interface',
    sectionItems: [
      {
        id: uuidv4(),
        name: 'Keyboards',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Startup Movies',
        amount: '5,000',
      },
    ],
  },
  {
    id: uuidv4(),
    title: 'Profile',
    sectionItems: [
      {
        id: uuidv4(),
        name: 'Avatars',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Backgrounds',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Community Awards',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Seasonal Badge',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Game Profiles',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Showcases',
        amount: '5,000',
      },
    ],
  },
  {
    id: uuidv4(),
    title: 'Chat',
    sectionItems: [
      {
        id: uuidv4(),
        name: 'Animated Stickers',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Chat Effects',
        amount: '5,000',
      },
      {
        id: uuidv4(),
        name: 'Emoticons',
        amount: '5,000',
      },
    ],
  },
];
